import React, { Component, Fragment } from 'react';
import ReactModal from 'react-modal';
import PropTypes from 'prop-types';
import { Dimmer, Loader } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';

import VideoUploader from './videoUploader';

// /*
//   // USAGE
//   <FileUploader
//     accept={'images/*'}
//     trigger={<button>Click</button>}
//     onChange={this.onChange}
//     cropRatios={['16:9', 'free', '1:1']}
//   />
//   */

class Modal extends Component {
  state = { stateOpen: false }

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  handleOpen = () => {
    this.setState({ stateOpen: true });
  };

  handleClose = () => {
    this.setState({ stateOpen: false });
  };

  render() {
    const { stateOpen } = this.state;
    const {
      trigger, open, translate, eventSlug, ...rest
    } = this.props;

    let shouldOpen = false;
    if (typeof open === 'boolean') {
      shouldOpen = open;
    }
    if (trigger !== null) {
      shouldOpen = stateOpen;
    }

    // TODO temp
    const isLoading = false;

    return (
      <Fragment>
        { trigger && (
          <a onClick={this.handleOpen} className='reactCrop_trigger'>
            {trigger}
          </a>
        ) }
        <ReactModal
          isOpen={shouldOpen}
          onRequestClose={this.handleClose}
          className='reactModal editProfileImg reactCrop'
          overlayClassName='reactModal_overlay'
          ariaHideApp={false}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          <Dimmer.Dimmable dimmed={isLoading}>
            <Dimmer active={isLoading}>
              <Loader>
                {translate('uploader.text.loading')}
              </Loader>
            </Dimmer>
            <section className='reactModal_content'>
              <a onClick={this.handleClose} className='reactModal_close'>
                {translate('uploader.button.close')}
              </a>
              <VideoUploader
                eventSlug={eventSlug}
                {...rest}
                postChange={this.handleClose}
              />
            </section>
          </Dimmer.Dimmable>
        </ReactModal>
      </Fragment>
    );
  }
}

Modal.propTypes = {
  trigger: PropTypes.node,
  open: PropTypes.bool,
  onRef: PropTypes.func,
  accept: PropTypes.string,
  cropRatios: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func
};

Modal.defaultProps = {
  trigger: null,
  open: undefined,
  onRef: undefined,
  accept: undefined,
  onChange: () => {},
  cropRatios: []
};

export default withLocalize(Modal);



// WEBPACK FOOTER //
// ./src/components/uploader/VideoModal.js